import request from '../request.js'
// 新增人员：获取待选择人员分页列表（张卫华）
const getUnUserTenantTablePageList = function (data) {
    return request({
        url: 'sysUserDeptTenant/getUnUserTenantTablePageList',
        method: 'post',
        data
    })
}
// 批量保存选择人员信息（张卫华）
const saveDeptTenantUserBatch = function (data) {
    return request({
        url: 'sysUserDeptTenant/saveDeptTenantUserBatch',
        method: 'post',
        data
    })
}

export {
    getUnUserTenantTablePageList,
    saveDeptTenantUserBatch,
}